export default __webpack_public_path__ + "static/media/dashboard.d2866bcc.svg";